import { MutationTree } from 'vuex';
import { ArticleDto } from '@/dto/Article.dto';
import { IArticleListState } from '@/store/interfaces';

export const mutations: MutationTree<IArticleListState> = {
  SET_ARTICLE_LIST(state, payload: ArticleDto[]) {
    state.articleList = payload;
  },
};
